/* ============================================================
   BUBINNA — Product page section behaviour
   Save as: assets/bubinna-product.js
   Wrapped so it re-initialises in the Theme Editor and never
   leaks globals into the theme.
   ============================================================ */
(function () {
  function initBubinnaPDP(root) {
    if (!root || root.dataset.bubinnaInit === "true") return;
    root.dataset.bubinnaInit = "true";

    var moneyFormat = root.dataset.moneyFormat || "${{amount}}";
    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
    }

    /* ---- Gallery ---- */
    var main = root.querySelector("[data-main-img]");
    root.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (main) {
  main.src = t.dataset.full;
  main.srcset = "";
  main.alt = t.querySelector("img") ? t.querySelector("img").alt : main.alt;
}

        root.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
      });
    });

    /* ---- Variants ---- */
    var variantData = [];
    var dataEl = root.querySelector("[data-variant-json]");
    if (dataEl) {
      try { variantData = JSON.parse(dataEl.textContent); } catch (e) { variantData = []; }
    }
    var selected = {};
    var idField = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-price]");
    var addBtn = root.querySelector("[data-add]");

    root.querySelectorAll("[data-option-index]").forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10);
      var first = group.querySelector(".swatch");
      if (first) selected[idx] = first.dataset.value;
      group.querySelectorAll(".swatch").forEach(function (s) {
        s.addEventListener("click", function () {
          group.querySelectorAll(".swatch").forEach(function (x) { x.classList.remove("active"); });
          s.classList.add("active");
          var nameEl = group.querySelector("[data-option-name]");
          if (nameEl) nameEl.textContent = s.dataset.value;
          selected[idx] = s.dataset.value;
          resolveVariant();
        });
      });
    });

    function resolveVariant() {
      var match = variantData.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i + 1] === opt; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.innerHTML = formatMoney(match.price);
      if (match.image && main) {
  main.src = match.image;
  main.srcset = "";
  function getFilename(url) {
    return url.split('/').pop().split('?')[0];
  }
  var matchFile = getFilename(match.image);
  root.querySelectorAll("[data-thumb]").forEach(function (t) {
    t.classList.toggle("active", getFilename(t.dataset.full) === matchFile);
  });
}
      if (addBtn) {
        if (match.available) {
          addBtn.removeAttribute("disabled");
          //addBtn.textContent = addBtn.dataset.label + " · " + formatMoney(match.price);
          addBtn.textContent = addBtn.dataset.label;
        } else {
          addBtn.setAttribute("disabled", "disabled");
          addBtn.textContent = "Sold out";
        }
      }
    }

    /* ---- Quantity ---- */
    var qty = root.querySelector("[data-qty]");
    root.querySelectorAll("[data-step]").forEach(function (b) {
      b.addEventListener("click", function () {
        var d = parseInt(b.dataset.step, 10);
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + d);
      });
    });

    /* ---- FAQ accordion ---- */
    root.querySelectorAll(".faq-q").forEach(function (q) {
      q.addEventListener("click", function () {
        var item = q.parentElement;
        var a = item.querySelector(".faq-a");
        var open = item.classList.toggle("open");
        a.style.maxHeight = open ? a.scrollHeight + "px" : 0;
      });
    });

    /* ---- Collapsible info rows (shipping / refund / secure payment) ---- */
    root.querySelectorAll(".collapse-head").forEach(function (h) {
      h.addEventListener("click", function () {
        var row = h.parentElement;
        var body = row.querySelector(".collapse-body");
        var open = row.classList.toggle("open");
        body.style.maxHeight = open ? body.scrollHeight + "px" : 0;
      });
    });

    /* ---- Add to cart: AJAX so only the selected item + quantity are sent ----
       Sending an explicit items[] payload means any hidden fields other apps
       inject into the product form are ignored (this is what was inflating the
       quantity). After adding, we open the theme's cart drawer.            */
    function shopRoot() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
    }
    function getQty() {
      return qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
    }
    function openCart(data) {
      var drawer = document.querySelector("cart-drawer");
      // Dawn & most modern themes
      if (drawer && typeof drawer.renderContents === "function" && data && data.sections) {
        drawer.classList.remove("is-empty");
        drawer.renderContents(data);
        return;
      }
      if (drawer && typeof drawer.open === "function") { drawer.open(); return; }
      // Other drawer themes: trigger the cart toggle if there is one
      var toggle = document.querySelector(
        "[data-cart-drawer-toggle],.js-drawer-open-cart,.cart-toggle,#cart-icon-bubble,a[href$='/cart']"
      );
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      if (toggle) { toggle.click(); return; }
      // Last resort: go to the cart page
      window.location.href = shopRoot() + "cart";
    }
    function addToCart() {
      var id = idField ? idField.value : null;
      if (!id || !addBtn) return;
      var label = addBtn.innerHTML;
      addBtn.setAttribute("disabled", "disabled");
      addBtn.textContent = "Adding…";
      var drawer = document.querySelector("cart-drawer");
      var payload = { items: [{ id: id, quantity: getQty() }] };
      if (drawer) { payload.sections = "cart-drawer,cart-icon-bubble"; payload.sections_url = window.location.pathname; }
      fetch(shopRoot() + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload)
      })
        .then(function (res) { if (!res.ok) throw new Error("add failed"); return res.json(); })
        .then(function (data) {
          addBtn.removeAttribute("disabled");
          addBtn.innerHTML = label;
          openCart(data);
        })
        .catch(function () {
          addBtn.removeAttribute("disabled");
          addBtn.innerHTML = label;
          window.location.href = shopRoot() + "cart";
        });
    }
    var form = root.querySelector("form[action*='/cart/add']");
    if (form) {
      form.addEventListener("submit", function (e) { e.preventDefault(); addToCart(); });
    } else if (addBtn) {
      addBtn.addEventListener("click", function (e) { e.preventDefault(); addToCart(); });
    }
  }

  function initAll() {
    document.querySelectorAll(".bubinna-pdp").forEach(initBubinnaPDP);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  /* Re-init when the Theme Editor re-renders the section */
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector(".bubinna-pdp");
    if (root) { root.dataset.bubinnaInit = "false"; initBubinnaPDP(root); }
  });
})();